import React, { FC } from 'react';
import ImgLeader from '@/shared/pictures/leader.svg';
import { numWord } from '@/shared/utils/numWord';
import { IMemberTeam, MemberRole } from '../types';
import { Flex } from 'antd';
import { useStore } from '@/app/providers/StoreProvider';
import { MemberOptions } from './MemberOptions';
import { glueName } from '@/shared/utils/users';
import { BonusInfo } from './BonusInfo';


interface TeamMemberItemProps {
  place: number,
  member:IMemberTeam,
  leader: boolean
}

export const TeamMemberItem:FC<TeamMemberItemProps> = ({place,member,leader}) => {
  const {userStore} = useStore();
  const {user} = userStore;
  const myId = user.id;


  const getNameRole = (role:MemberRole) =>{
    switch(role){
      case MemberRole.CAPTAIN:
        return 'Лидер клана'
      case MemberRole.MEMBER:
        return 'Участник'
      default:
        const never:never = role
        return never
    }
  }

  return (
    <div className={`team-members_item ${myId == member.userId?'you':''}`}>
        <p className='team-members_number'>{place}</p>
        <div className='team-members_user'>
          <img className='team-members_icon' src={member.photoUrl} alt="icon" />
          <Flex vertical>
              <p className='team-members_name'>{glueName(member)} 
                {member.role == MemberRole.CAPTAIN&&<img src={ImgLeader} alt="leader" />}
              </p>
              <p className='team-members_role'>{getNameRole(member.role)}</p>
          </Flex>

        </div>
        {myId == member.userId&&
          <BonusInfo/>
        }
        <p className='team-members_pucks'>{member.score + ' ' + numWord(member.score, ['шайба','шайбы','шайб']) }</p>

        {
          leader&&
            member.role != MemberRole.CAPTAIN&&
              <MemberOptions member={member}/>
        }


    </div>
  );

};